import { BaseService } from "./BaseService";
import type {
  AnalyticsReservationsRangeQuery,
  ReservationsSummaryResponse,
} from "@/types/analytics-reservations";

class AnalyticsReservationsService extends BaseService {
  private readonly basePath = "/analytics/reservations";

  getSummary(
    query: AnalyticsReservationsRangeQuery,
  ): Promise<ReservationsSummaryResponse> {
    return this.get<ReservationsSummaryResponse>(
      `${this.basePath}/summary`,
      query,
    );
  }
}

export const analyticsReservationsService = new AnalyticsReservationsService();
